import { NgModule } from '@angular/core';
import { STATISTICS_ROUTES } from './statistics.routes';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StatisticsComponent } from './statistics.component';
import { ChartModule } from '@progress/kendo-angular-charts';
import { ContingentStatsComponent } from './contingent/contingent-stats.component';
import { RentedBikeStatsComponent } from './rented-bikes/rented-bikes-stats.component';
import { AppVersionsComponent } from './app-versions/app-versions.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { DialogModule } from '@progress/kendo-angular-dialog';

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(STATISTICS_ROUTES),
    FormsModule,
    CommonModule,
    ChartModule,
    GridModule,
    DialogModule
  ],
  exports: [],
  declarations: [
    StatisticsComponent,
    ContingentStatsComponent,
    RentedBikeStatsComponent,
    AppVersionsComponent
  ]
})
export class StatisticsModule {
}
